import type { ReactElement } from 'react';

import { EntityAuditTrail } from '../../../components/audit';

/**
 * Audit-log tab body for the report moderation drawer (AUT-127).
 *
 * Thin wrapper around the shared `<EntityAuditTrail>` placeholder
 * (`entityType="Report"`). Phase B ships only the "coming soon" stub —
 * the backing `GET /admin/logs?entityType=&entityId=` endpoint lands in
 * Phase D (architect 🟠 #1 acknowledgement). Wiring the real fetch is a
 * one-component swap in `components/audit/EntityAuditTrail.tsx`.
 */
export interface AuditTabProps {
  reportId: string;
}

export const AuditTab = ({ reportId }: AuditTabProps): ReactElement => (
  <EntityAuditTrail entityType="Report" entityId={reportId} />
);
